(function () {
  'use strict';

  function init(root) {
    if (root.__dtInit) return;
    root.__dtInit = true;

    var cfg = JSON.parse(root.querySelector('[data-dt-config]').textContent);
    function num(cents, dec, th, dp) {
      var s = (cents / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + th);
      return s.length > 1 ? s[0] + dp + s[1] : s[0];
    }
    function money(cents) {
      return String(cfg.moneyFormat).replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        switch (k) {
          case 'amount_no_decimals': return num(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
          case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', '.');
          case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
          default: return num(cents, 2, ',', '.');
        }
      });
    }

    var state = { mode: root.getAttribute('data-mode'), plan: null };
    var plans = [].slice.call(root.querySelectorAll('[data-plan]'));
    if (plans.length) state.plan = plans[0];

    var cta = root.querySelector('[data-cta]');
    var ctaLabel = root.querySelector('[data-cta-label]');

    /* sticky pill: separate element portaled to <body> (outside any section stacking context) */
    var sectionEl = root.closest('.shopify-section') || root;
    var old = document.querySelectorAll('.dt-sticky-cta[data-for="' + sectionEl.id + '"]');
    [].forEach.call(old, function (n) { n.remove(); });
    var pill = document.createElement('div');
    pill.className = 'dt-sticky-cta';
    pill.setAttribute('data-for', sectionEl.id);
    var pillBtn = document.createElement('button');
    pillBtn.type = 'button';
    pillBtn.className = 'dt-sticky-cta__btn';
    pillBtn.setAttribute('aria-busy', 'false');
    var pillLabel = document.createElement('span');
    pillBtn.appendChild(pillLabel);
    pill.appendChild(pillBtn);
    var rs = getComputedStyle(root);
    pill.style.setProperty('--dt-btn', rs.getPropertyValue('--dth-btn'));
    pill.style.setProperty('--dt-btn-text', rs.getPropertyValue('--dth-btn-text'));
    document.body.appendChild(pill);
    // the sticky pill runs the exact same add-to-cart as the main CTA (no scroll, no navigation)
    pillBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); addToCart(); });
    function setBusy(v) {
      cta.setAttribute('aria-busy', v ? 'true' : 'false');
      pillBtn.setAttribute('aria-busy', v ? 'true' : 'false');
    }
    var errorEl = root.querySelector('[data-error]');

    /* ---------- pricing / UI state ---------- */
    function totals() {
      var value = cfg.mainValue; // main compare-at + gifts' compare-at (the paid filter is never part of the kit)
      cfg.gifts.forEach(function (g) { value += g.value * g.qty; });
      return { total: cfg.mainPrice, value: value };
    }

    function render() {
      var t = totals();
      root.setAttribute('data-mode', state.mode);
      var priceStr = money(t.total);
      var parts = cfg.text.cta.split('[price]');
      ctaLabel.textContent = '';
      ctaLabel.appendChild(document.createTextNode(parts[0]));
      var strong = document.createElement('strong');
      strong.textContent = priceStr;
      ctaLabel.appendChild(strong);
      if (parts[1]) ctaLabel.appendChild(document.createTextNode(parts.slice(1).join('[price]')));
      pillLabel.innerHTML = ctaLabel.innerHTML;

      var one = root.querySelector('[data-one-price]');
      if (one) one.textContent = priceStr;

      var link = root.querySelector('[data-set-mode="onetime"]');
      if (link) link.textContent = cfg.text.linkOne.replace('[price]', priceStr);

      if (cfg.hasPlans) {
        plans.forEach(function (p) {
          var on = p === state.plan;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var f = root.querySelector('[data-sum-filters]');
        if (f && state.plan) {
          f.textContent = cfg.text.filtersLine
            .replace('[price]', money(parseInt(state.plan.getAttribute('data-plan-price'), 10)))
            .replace('[interval]', state.plan.getAttribute('data-plan-interval'));
        }
      }
      // summary total + crossed-out compare value, in both modes
      var tot = root.querySelector('[data-sum-total]');
      var cmp = root.querySelector('[data-sum-compare]');
      if (tot) tot.textContent = priceStr;
      if (cmp) cmp.textContent = t.value > t.total ? money(t.value) : '';
    }

    plans.forEach(function (p) {
      p.addEventListener('click', function () { state.plan = p; render(); });
    });
    [].forEach.call(root.querySelectorAll('[data-set-mode]'), function (b) {
      b.addEventListener('click', function () {
        state.mode = b.getAttribute('data-set-mode');
        render();
      });
    });

    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-track]');
    var slides = track ? [].slice.call(track.children) : [];
    var dotsWrap = root.querySelector('[data-dots]');
    var dots = [];
    var active = 0;

    function playActive() {
      slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (!v) return;
        if (i === active) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else v.pause();
      });
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    if (track && slides.length) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'dth-dot-b' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', String(i + 1));
        d.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(d);
        dots.push(d);
      });
      var tick = false;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        requestAnimationFrame(function () {
          tick = false;
          var x = track.scrollLeft, best = 0, bd = Infinity;
          slides.forEach(function (s, i) {
            var d = Math.abs(s.offsetLeft - track.offsetLeft - x);
            if (d < bd) { bd = d; best = i; }
          });
          if (best !== active) {
            active = best;
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
            playActive();
          }
        });
      }, { passive: true });
      root.querySelector('[data-prev]').addEventListener('click', function () { goTo(active - 1); });
      root.querySelector('[data-next]').addEventListener('click', function () { goTo(active + 1); });
      playActive();
    }

    /* ---------- sticky CTA ---------- */
    var wrap = root.querySelector('[data-cta-wrap]');
    function applySticky(visible) { pill.classList.toggle('is-on', !visible); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { applySticky(e[e.length - 1].isIntersecting); }).observe(wrap);
    }

    /* ---------- add to cart ---------- */
    function showError(msg) { errorEl.textContent = msg || ''; }

    /* ---------- drawer: same flow as Shrine's native product form ---------- */
    var DRAWER_SECTIONS = 'cart-drawer,cart-icon-bubble';
    function drawerHasItems(drawer) { return drawer.querySelectorAll('.cart-drawer-item').length > 0; }
    function fetchSections() {
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=' + DRAWER_SECTIONS, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); });
    }
    // native handler passes renderContents() the add.js response of ONE line item (with id/key/variant_id...) plus .sections
    function renderDrawer(drawer, sections, items) {
      var first = (items && items[0]) || {};
      var state = {};
      for (var k in first) if (Object.prototype.hasOwnProperty.call(first, k)) state[k] = first[k];
      state.sections = sections;
      state.items = items;
      drawer.renderContents(state);
      drawer.classList.remove('is-empty');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
    function showDrawer(drawer, data) {
      var items = data.items || [data];
      if (window.dtRenderCartDrawer) return window.dtRenderCartDrawer(items, data.sections, { open: true }); // shared renderer (dt-gift-sync.js)
      var goCart = function () { window.location.href = '/cart'; };
      if (!drawer || typeof drawer.renderContents !== 'function') { goCart(); return; }
      var ensureOpen = function () {
        if (typeof drawer.open === 'function' && !drawer.classList.contains('active')) { try { drawer.open(); } catch (e) {} }
      };
      var attempt = function (sections, retry) {
        try { renderDrawer(drawer, sections, items); } catch (e) {
          if (retry) return fetchSections().then(function (s) { return attempt(s, false); }).catch(goCart);
          goCart(); return;
        }
        if (!drawerHasItems(drawer)) { // never leave an empty drawer
          if (retry) return fetchSections().then(function (s) { return attempt(s, false); }).catch(goCart);
          goCart(); return;
        }
        ensureOpen();
      };
      if (data.sections && data.sections['cart-drawer']) return attempt(data.sections, true);
      return fetchSections().then(function (s) { return attempt(s, false); }).catch(goCart);
    }

    var adding = false;
    function addToCart() {
      if (adding) return; // ignore repeated clicks until the request ends
      adding = true;
      showError('');
      var sub = state.mode === 'subscription' && state.plan;
      // /cart.js (and checkout) list the most recently added line first, so the main product goes LAST in the request
      var items = [];
      cfg.gifts.forEach(function (g) { items.push({ id: g.id, quantity: g.qty }); });
      if (sub) { // Filter Cartridges ($14.99, paid refill) only goes in with a selling plan
        items.push({ id: cfg.filterId, quantity: 1, selling_plan: parseInt(state.plan.getAttribute('data-plan-id'), 10) });
      }
      items.push({ id: cfg.mainId, quantity: 1 });

      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }

      setBusy(true);
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || cfg.text.error);
          return showDrawer(drawer, res.json);
        })
        .catch(function (err) {
          showError(err && err.message ? err.message : cfg.text.error);
        })
        .then(function () { setBusy(false); adding = false; });
    }
    cta.addEventListener('click', function (e) { e.preventDefault(); addToCart(); });

    render();
  }

  function boot() {
    [].forEach.call(document.querySelectorAll('[data-dt-hero]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
